import React, { Component } from 'react';
import StartView from '../../views/startView/StartView';
import styled from 'styled-components';
import Navbar from '../../views/shared/navbar/Navbar';
import Footer from '../../views/shared/footer/Footer';

const PageWrapper = styled.div`
	width: 100%;
	height: 100vh;
`;

type Props = {};

type State = {};

class MainPage extends Component<Props, State> {
	state = {};

	render() {
		return (
			<PageWrapper>
				<Navbar variant="transparent" />
				<StartView />
				<Footer />
			</PageWrapper>
		);
	}
}

export default MainPage;
